/**
 * Section Break Logic
 * Handles showing/hiding decorative break elements between sections
 */
document.addEventListener('DOMContentLoaded', function () {
    function handleSectionBreaks() {
        // Handle low breaks (show if next section has white background)
        const lowBreakElements = document.querySelectorAll('.section-break-low')
        // console.log(
        //     'Found',
        //     lowBreakElements.length,
        //     'low section break elements'
        // )

        lowBreakElements.forEach((breakEl, index) => {
            // Find the next section
            const nextSection = breakEl.parentElement.nextElementSibling
            // console.log(`Low break element ${index}:`, breakEl)
            // console.log(`Next section:`, nextSection)

            if (nextSection) {
                // Look for background-image-container with bg-white class inside the next section
                const bgContainer = nextSection.querySelector(
                    '.background-image-container.bg-white'
                )
                // console.log(`Background container with bg-white:`, bgContainer)

                if (bgContainer) {
                    // Show the break if next section has white background
                    breakEl.classList.add('show')
                    // console.log(`Showing low break element ${index}`)
                } else {
                    // Hide the break
                    breakEl.classList.remove('show')
                    // console.log(`Hiding low break element ${index}`)
                }
            } else {
                // Hide the break if there's no next section
                breakEl.classList.remove('show')
                // console.log(
                //     `No next section, hiding low break element ${index}`
                // )
            }
        })

        // Handle high breaks (show if previous section has white background)
        const highBreakElements = document.querySelectorAll(
            '.section-break-high'
        )
        // console.log(
        //     'Found',
        //     highBreakElements.length,
        //     'high section break elements'
        // )

        highBreakElements.forEach((breakEl, index) => {
            // Find the previous section
            const previousSection = breakEl.parentElement.previousElementSibling
            // console.log(`High break element ${index}:`, breakEl)
            // console.log(`Previous section:`, previousSection)

            if (previousSection) {
                // Look for background-image-container with bg-white class inside the previous section
                const bgContainer = previousSection.querySelector(
                    '.background-image-container.bg-white'
                )
                // console.log(`Background container with bg-white:`, bgContainer)

                if (bgContainer) {
                    // Show the break if previous section has white background
                    breakEl.classList.add('show')
                    // console.log(`Showing high break element ${index}`)
                } else {
                    // Hide the break
                    breakEl.classList.remove('show')
                    // console.log(`Hiding high break element ${index}`)
                }
            } else {
                // Hide the break if there's no previous section
                breakEl.classList.remove('show')
                // console.log(
                //     `No previous section, hiding high break element ${index}`
                // )
            }
        })
    }

    // Run on page load
    handleSectionBreaks()

    // Run on window resize (in case of responsive changes)
    window.addEventListener('resize', handleSectionBreaks)

    // Run when sections are dynamically loaded
    const observer = new MutationObserver(handleSectionBreaks)
    observer.observe(document.body, {
        childList: true,
        subtree: true,
    })
})
